module.exports = __webpack_public_path__ + "img/20190612_132334_019.1800c6f3.jpg";